module.exports = __webpack_public_path__ + "img/hover_icon_compensatory_hours.9723cd1f.svg";